import { render, staticRenderFns } from "./nodata.vue?vue&type=template&id=aae6daf4"
import script from "./nodata.vue?vue&type=script&lang=js"
export * from "./nodata.vue?vue&type=script&lang=js"
import style0 from "./nodata.vue?vue&type=style&index=0&id=aae6daf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports